module.exports = "img/ai_logo.png";